module.exports = __webpack_public_path__ + "media/effect-rotate.2219faae.mp4";